import { fetchCurrentUser } from '../../ducks/user.duck';

export const loadData = () => {
  return fetchCurrentUser();
};
